import $ from 'jquery';
import {min} from "lodash";
import { generateAdSlot } from 'utils/adManager';


class AdsSlots
{
    constructor()
    {
        this.loading = false;
        this.scrolling = true;
    }

    init()
    {
        const addSlot = "/52555387,21308365/rmadryt.pl_300x250_infinite_1"

        document.addEventListener('CommentsViewRendered', function() {
            const comments = $('#c-comments .comments-list__base').find('> article');

            for (let [i, adId] = [4, 1]; i < min([comments.length, 25]); i += 5, adId++) {
                generateAdSlot(addSlot, [[300, 250], [336, 280]], comments[i], comments[i-1], "rmpl-comment-ad");
            }
        });
    }
}

export default new AdsSlots();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/ads-slots.js